import { useNavigate } from 'react-router-dom'
import { useMetro } from '../context/MetroContext'

function Cities() {
  const navigate = useNavigate()
  const { cities, selectedCity, setSelectedCity } = useMetro()

  const operationalCities = cities.filter(c => c.isOperational)
  const plannedCities = cities.filter(c => !c.isOperational)

  const handleSelectCity = (cityId: string) => {
    setSelectedCity(cityId as any)
    navigate('/')
  }

  return (
    <div className="py-8 lg:py-12">
      <div className="container-responsive">
        <h1 className="text-3xl lg:text-4xl 2xl:text-tv-2xl font-bold text-center mb-4">
          Select Your City
        </h1>
        <p className="text-center text-neutral-dark/70 mb-12 max-w-2xl mx-auto">
          Choose from {cities.length} Indian cities with metro rail networks.
          Select a city to explore routes, fares, and stations.
        </p>

        {/* Operational Cities */}
        <div className="mb-12">
          <h2 className="text-xl lg:text-2xl font-semibold mb-6 flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-metro-green"></span>
            Operational Cities ({operationalCities.length})
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
            {operationalCities.map((city) => (
              <button
                key={city.id}
                onClick={() => handleSelectCity(city.id)}
                className={`card text-left hover:border-metro-blue hover:shadow-lg transition-all tv-focusable ${
                  selectedCity === city.id ? 'border-2 border-metro-blue bg-metro-blue-soft' : ''
                }`}
              >
                <h3 className="text-lg font-semibold mb-2">{city.name}</h3>
                <p className="text-sm text-neutral-dark/70 mb-1">{city.metroName}</p>
                <div className="text-sm text-neutral-dark/70">
                  <p>{city.stationCount} Stations</p>
                  <p>{city.lineCount} Lines</p>
                </div>
                <div className="mt-3 flex items-center gap-1 text-metro-green text-sm">
                  <span className="w-2 h-2 rounded-full bg-metro-green"></span>
                  Operational
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Planned Cities */}
        {plannedCities.length > 0 && (
          <div>
            <h2 className="text-xl lg:text-2xl font-semibold mb-6 flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-metro-yellow"></span>
              Coming Soon ({plannedCities.length})
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
              {plannedCities.map((city) => (
                <div
                  key={city.id}
                  className="card opacity-60 cursor-not-allowed"
                >
                  <h3 className="text-lg font-semibold mb-2">{city.name}</h3>
                  <p className="text-sm text-neutral-dark/70 mb-1">{city.metroName}</p>
                  <div className="mt-3 flex items-center gap-1 text-metro-yellow text-sm">
                    <span className="w-2 h-2 rounded-full bg-metro-yellow"></span>
                    Under Construction
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Cities
